import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TooltipModule, BsDropdownModule, ModalModule } from 'ngx-bootstrap';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { UserNotificationsComponent } from './user-notifications.component';
import { UserNotificationsActionsModalComponent } from './user-notifications-actions-modal/user-notifications-actions-modal.component';
import { ReviewCandidatePullFromJobBoardsModule } from '../review-candidate-pull-from-job-boards/review-candidate-pull-from-job-boards.module';
import { JobProfileModule } from 'src/app/pages/mission-control-page/job-profile-page/job-profile/job-profile.module';
import { CandidateJobMatchProfileModule } from 'src/app/shared/candidate-job-match-profile/candidate-job-match-profile.module';
import { CandidateCardIconsModule } from 'src/app/shared/candidate-card-icons/candidate-card-icons.module';
import { UploadResumesProcessedCandidatesModule } from 'src/app/pages/mission-control-page/add-candidates-page/upload-resumes/upload-resumes-processed-candidates/upload-resumes-processed-candidates.module';
import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';
import { ViewAssessmentReportModule } from 'src/app/shared/job-match-actions/view-assessment-report/view-assessment-report.module';

// UserNotificationsActionsModalComponent (the native port of the legacy
// userNotificationsActionModal $uibModal template/controller) is declared in this same
// module, rather than getting its own feature module, because its 'viewAllNotifications'
// actionType embeds <app-user-notifications> - i.e. it recursively references
// UserNotificationsComponent. Splitting them into two modules that import each other
// would be a circular NgModule import, which Angular does not support.
@NgModule({
  declarations: [UserNotificationsComponent, UserNotificationsActionsModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    InfiniteScrollModule,
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    PipesModule,
    ReviewCandidatePullFromJobBoardsModule,
    JobProfileModule,
    CandidateJobMatchProfileModule,
    CandidateCardIconsModule,
    UploadResumesProcessedCandidatesModule,
    SkeletonLoaderModule,
    ViewAssessmentReportModule
  ],
  exports: [UserNotificationsComponent, UserNotificationsActionsModalComponent],
  entryComponents: [UserNotificationsComponent, UserNotificationsActionsModalComponent]
})
export class UserNotificationsModule { }
